import request from '@/utils/request'

// 查询方案基本信息
export function getSolutionById(params) {
  return request({
    url: '/system/solution/getSolutionById',
    method: 'get',
    params
  })
}

// 修改方案基本信息
export function updateSolutionBasic(data) {
  return request({
    url: '/system/solution/updateSolutionBasic',
    method: 'post',
    data
  })
}

// 查询方案核心内容
export function getSolutionCoreBySolutionId(params) {
  return request({
    url: '/system/solution/getSolutionCoreBySolutionId',
    method: 'get',
    params
  })
}

// 查询解决方案服务
export function getSolutionServiceBySolutionId(params) {
  return request({
    url: '/system/solution/getSolutionServiceBySolutionId',
    method: 'get',
    params
  })
}

// 修改解决方案服务
export function updateSolutionService(data) {
  return request({
    url: '/system/solution/updateSolutionService',
    method: 'post',
    data
  })
}

// 查询实体关联
export function getEntityById(params) {
  return request({
    url: '/system/solution/getEntityById',
    method: 'get',
    params
  })
}

// 查询解决方案资料
export function getSolutionFile(params) {
  return request({
    url: '/system/solution/getSolutionFile',
    method: 'get',
    params
  })
}

// 修改解决方案资料
export function updateSolutionFile(data) {
  return request({
    url: '/system/solution/updateSolutionFile',
    method: 'post',
    data
  })
}

// 根据查询条件查询报告数据一览信息
export function getSolutionList(data) {
  return request({
    url: '/system/solution/getSolutionList',
    method: 'post',
    data
  })
}

// 删除方案
export function deleteSolutionById(data) {
  return request({
    url: '/system/solution/deleteSolutionById',
    method: 'post',
    data
  })
}